const similarity = require("compute-cosine-similarity");

function getCosineSimilarityRowVector(matrix, index) {
  return matrix.map((rowRelative, i) => {
    return similarity(matrix[index], matrix[i]);
  });
}

function sortByScore(array) {
  return array.sort((a, b) => b.score - a.score);
}


module.exports = {
  getCosineSimilarityRowVector,
  sortByScore,
};
